$(document).ready(function () {
    // 解析 URL 的 Path，取得當前頁面的 action。
    const urlPath = window.location.pathname;
    let currentActionViewName = urlPath.split('/').pop();

    // 設置 active
    setActiveItem(currentActionViewName);

    // 點擊選單事件處理
    $('.list-group-item').on('click', function (e) {
        let actionViewName = $(this).find('a').data('view_action');

        setActiveItem(actionViewName);
    });
});

// function-設置選單的 active 狀態
function setActiveItem(actionViewName) {
    $('.list-group-item').removeClass('active');
    $(`.list-group-item a[data-view-action="${actionViewName}"]`).closest('.list-group-item').addClass('active');
}
